/**
 * Shared layout components for detail tab views.
 * Eliminates structural duplication across *Tabs.jsx files.
 */

export function DetailsTabLayout({ tabs, children }) {
  return (
    <div class="detailsContainer">
      <ul class="nav nav-tabs">
        {tabs.map((tab, i) => (
          <li class="nav-item">
            <a
              class={['nav-link', i === 0 && 'active', tab.disabled && 'disabled']}
              data-bs-target={'#' + tab.id}
              role="tab"
              data-bs-toggle="tab"
              aria-selected={i === 0 ? 'true' : 'false'}
              aria-expanded={i === 0 ? 'true' : 'false'}>
              {tab.label}
            </a>
          </li>
        ))}
      </ul>
      <div class="tab-content detailsTab">{children}</div>
    </div>
  );
}

export function TabPane({ id, active, name, children }) {
  return (
    <div class={'tab-pane fade' + (active ? ' active show' : '')} id={id} role="tabpanel">
      <div class="row" name={name}>
        {children}
      </div>
    </div>
  );
}

export function DetailSection({ title, children }) {
  return (
    <div class="detailsContent">
      <h4>{title}</h4>
      <div>{children}</div>
    </div>
  );
}
